import cx from 'classnames';
import { COMMENT_DELETED_BY_ADMIN, COMMENT_DELETED_BY_AUTHOR, SHOW } from 'mk/autogenerated/translations/CommentHeader.99ae2ee97ecd9c89119992d9c2581074'
import CommentHeaderName from 'mk2/apps/blogs/components/CommentHeaderName';
import { UserChip } from 'mk2/apps/forum/components/UserChip';
import { CounsellingCounsellorEntity } from 'mk2/apps/forum/schemas';
import { Btn,  BtnSidePadding, BtnType } from 'mk2/components/Btn';
import { DeletedByRole } from 'mk2/helpers/deleteable';
import { timeAt } from 'mk2/helpers/timeformat';
import { CommentEntity, UserEntity } from 'mk2/schemas';
import React from 'react';
import styles from './CommentHeader.mscss';

interface OwnProps {
    className?: string;
    comment: CommentEntity;
    isCollapsed: boolean;
    inForum: boolean;
    isPostAuthor: boolean;
    isMyAnonymousComment?: boolean;
    inGroups?: boolean;
    moderators?: UserEntity[];
    counsellor?: CounsellingCounsellorEntity;

    onToggleDeletedDetails();
}

type Props = OwnProps;

export class CommentHeader extends React.Component<Props> {
    public render() {
        const {
            className,
            comment,
            counsellor,
            inForum,
            inGroups,
            isCollapsed,
            isPostAuthor,
            isMyAnonymousComment,
            moderators,
            onToggleDeletedDetails,
        } = this.props;

        const showCreateTime =
            (!comment.deletedAt || (comment.deletedAt && !isCollapsed)) &&
            comment.created &&
            !counsellor;
        const showDeletedMessage = comment.deletedAt && isCollapsed;

        return inForum ? (
            <div
                className={cx(
                    styles.CommentHeader,
                    styles['CommentHeader--inForum'],
                    counsellor && styles['CommentHeader--counsellingHeader'],
                    className,
                )}
            >
                <CommentHeaderName
                    comment={comment}
                    inForum={inForum}
                    inGroups={inGroups}
                    isPostAuthor={isPostAuthor}
                    isMyAnonymousComment={isMyAnonymousComment}
                    moderators={moderators}
                    counsellor={counsellor}
                />

                {showCreateTime && (
                    <>
                        <div className={styles.CommentHeader__sep}>•</div>
                        <span>{timeAt(comment.created)}</span>
                    </>
                )}

                {showDeletedMessage && (
                    <>
                        <div className={styles.CommentHeader__sep}>•</div>
                        <div>
                            {comment.deletedByRole === DeletedByRole.DeletedByAuthor
                                ? COMMENT_DELETED_BY_AUTHOR
                                : COMMENT_DELETED_BY_ADMIN}
                        </div>
                        <div className={styles.CommentHeader__sep}>
                            •
                        </div>
                        <Btn
                            onClick={onToggleDeletedDetails}
                            label={SHOW}
                            sidePadding={BtnSidePadding.None}
                            type={BtnType.BlueTextLight}
                            classNames={{ label: styles.CommentHeader__deletedBtnLabel }}
                        />
                    </>
                )}
            </div>
        ) : (
            <div className={cx(styles.CommentHeader, styles['CommentHeader--inGroupsOrBlogs'])}>
                <UserChip
                    size={32}
                    user={comment.authorUser}
                    showUsername={false}
                />
            </div>
        );
    }
}
